/**
 * The table both portals show a list of rows in.
 *
 * Lives here rather than in either app because the bot screens are now built once
 * and rendered in both, and a shared component that reaches back into one app's
 * primitives is a shared component in name only.
 */
/** Wide tables scroll inside their own container so the page never does. */
export function DataTable({ head, children }: { head: string[]; children: React.ReactNode }) {
  return (
    <div className="overflow-x-auto rounded border border-(--color-line) bg-(--color-surface)">
      <table className="w-full border-collapse text-body">
        <thead>
          <tr>
            {head.map((label) => (
              <th
                key={label}
                className="border-b border-(--color-line) bg-(--color-canvas) px-4 py-2.5 text-left text-micro font-medium tracking-wide text-(--color-muted) uppercase whitespace-nowrap"
              >
                {label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>{children}</tbody>
      </table>
    </div>
  );
}

export function Cell({ children, mono = false, nowrap = false }: {
  children: React.ReactNode; mono?: boolean; nowrap?: boolean;
}) {
  return (
    <td className={[
      'border-b border-(--color-line) px-4 py-2.5 align-top',
      mono ? 'font-mono text-small' : '',
      nowrap ? 'whitespace-nowrap' : '',
    ].join(' ')}>
      {children}
    </td>
  );
}

export function Empty({ children }: { children: React.ReactNode }) {
  return <p className="px-4 py-8 text-center text-body text-(--color-muted)">{children}</p>;
}

